import classNames from "classnames";
import scss from "@/styles/pages/support/support-hero.module.scss";

export const wrapper = classNames(
    // Mobile
    // Tablet
    // All
    "flex",
    "flex-row",
    "items-center",
    "z-10",
    "h-fit",
    scss["wrapper"]
);

export const image = classNames(
    // Mobile
    "mobile:w-auto",
    "mobile:h-44",
    // Tablet
    "tablet:w-full",
    "tablet:h-full",
    // All
    "z-0"
);

export const headingContainer = classNames(
    "mobile:w-full",
    "mobile:justify-center",
    "mobile:items-center",
    "mobile:absolute",
    "mobile:m-8",
    "mobile:pb-6",
    // Tablet
    "tablet:right-0",
    "tablet:w-auto",
    "tablet:m-0",
    "tablet:items-center",
    "tablet:justify-center",
    "tablet:relative",
    // All
    "flex",
    "flex-row",
    // "relative",
    "z-50"
)

export const content = classNames(
    // Mobile
    "mobile:text-start",
    // Tablet
    "tablet:text-center",
    // All
);

export const subheading = classNames(
    // Mobile
    "mobile:pt-2",
    "mobile:text-sm",
    // Tablet
    "tablet:pt-6",
    "tablet:text-start",
    "tablet:text-2xl",
    // All
);
